import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AppRedirectionService } from './guards/app.redirection.service';
import { LegalNoticeComponent } from './components/legal-notice/legal-notice.component';
import { CguComponent } from './components/cgu/cgu.component';
import { ErrorComponent } from './modules/shared/components/error/error.component';
import { SiteMapComponent } from './components/site-map/site-map.component';
import { AccessibilityComponent } from './components/accessibility/accessibility.component';

const routes: Routes = [
  {path: 'accueil', component: HomeComponent, pathMatch: 'full'},
  {path: 'verifier', loadChildren: () => import('./modules/verification/verification.module').then(m => m.VerificationModule)},
  {path: 'signer', loadChildren: () => import('./modules/signature/signature.module').then(m => m.SignatureModule)},
  {path: 'erreur', component: ErrorComponent, canActivate: [AppRedirectionService]},
  {path: 'donnees-personnelles-et-securite', component: LegalNoticeComponent},
  {path: 'cgu', component: CguComponent},
  {path: 'plan-du-site', component: SiteMapComponent},
  {path: 'accessibilite', component: AccessibilityComponent},
  {path: '**', component: HomeComponent},
];

@NgModule({
  providers: [
    AppRedirectionService,
  ],
  imports: [RouterModule.forRoot(routes, {useHash: true, anchorScrolling: 'enabled'})],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
